/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import ClassroomRouteLinkItem from './ClassroomRouteLinkItem';
import RosterIcon from 'icons/RosterIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.roster'},
});

const RosterItem = () => {
  const [{classroom}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/pd-section/${classroom.sectionID}?fields=id`,
    expectedStatus: [200, 404],
  });

  // If a PD section does exist, don't show the academic roster link (this item)
  if (response.json?.section) {
    return null;
  }

  return (
    <ClassroomRouteLinkItem
      iconBefore={RosterIcon}
      route="midas/classroom/roster"
      title={messages.title}
    />
  );
};
export default RosterItem;
